import { Button } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import $t from '../../../../i18n'
import Dialog from '../../../common/Dialog'
import Actions from '../../../../actions'
import { getContactSupportUrl } from '../../../../consts'
import { getIsHmoMember } from '../../../../utils/hmoUtils'

const NoServiceDialog = () => {
  const dispatch = useDispatch()
  const validStates = useSelector(state => state.app?.validStates)
  const isNoServiceDialogVisible = useSelector(
    state => state.payment.isNoServiceDialogVisible
  )
  const userDetails = useSelector(state => state.profile?.userDetails)
  const isHmoMember = getIsHmoMember(userDetails)
  const states = validStates.join(', ')

  const onEndSession = () => {
    dispatch(Actions.createAction(Actions.SIGNOUT_REQUESTED))
    dispatch(Actions.createAction(Actions.DISBALE_NO_SERVICE_DIALOG))
  }

  const noServiceDialogActions = [
    <Button
      key="2"
      className="dialog-action"
      type="primary"
      onClick={() => {
        window.open(getContactSupportUrl(isHmoMember))
        onEndSession()
      }}
    >
      {$t('serviceLocation.link')}
    </Button>,
    <Button
      key="1"
      className="dialog-action"
      type="secondary"
      onClick={onEndSession}
    >
      {$t('serviceLocation.endSession')}
    </Button>,
  ]

  return (
    <>
      <Dialog
        title={$t('serviceLocation.title')}
        isVisible={isNoServiceDialogVisible}
        footerActions={noServiceDialogActions}
        onCancel={onEndSession}
        className="declare-location-dialog"
      >
        <div className="dialog-content">
          <div className="subtitle">
            {$t('serviceLocation.message', { states })}
          </div>
        </div>
      </Dialog>
    </>
  )
}

export default NoServiceDialog
